import {NgModule} from '@angular/core';
import {InlineLoaderModule} from './components/inline-loader/inline-loader.module';
import {RoleGuard} from './auth/guards/role.guard';
import {AuthenticationService} from './auth/authentication.service';
import {CookieService} from 'ngx-cookie-service';
import {AppRedirectService} from './auth/app-redirect.service';

@NgModule({
    imports: [
        InlineLoaderModule,
    ],
    exports: [],
    declarations: [
    ],
    providers: [
        RoleGuard,
        AuthenticationService,
        CookieService,
        AppRedirectService,
    ],
})

export class CommonModule {
}
